module.exports = __webpack_public_path__ + "img/Bbond.6bdbeb78.svg";